// @ts-ignore
export const getNowUnixTimestamp = () => Math.floor(new Date() / 1000)
